import React from "react"
import {Box, Button, Container} from "@material-ui/core";
import logo from "../images/logo.png"

function Header() {
    return (
        <Box className="page-header">
            <Box className="main-header">
                <Container className="main-header-container">
                    <Box className="app-logo"><img src={logo} className="app-logo" alt="site logo" /></Box>
                    <Box className="header-links">
                        <Button className="secondary-buttons">HOME</Button>
                        <Button>WORLD RECORDS</Button>
                        <Button>LOCAL RECORDS</Button>
                        <Button>PRESS KIT</Button>
                        <Button>CONTACT</Button>
                    </Box>
                </Container>
            </Box>
            <Box className="secondary-header">
                <Container className="secondary-header-container">
                    <Box className="secondary-header-links">
                        <Button className="secondary-buttons">Past Winners</Button>
                        <Button className="secondary-buttons">Moms In The News</Button>
                        <Button className="secondary-buttons">MOFC</Button>
                        <Button className="secondary-buttons">Vegan Recipes</Button>
                        <Button className="secondary-buttons">Best Dads</Button>
                        <Button className="secondary-buttons">Snarky Children</Button>
                    </Box>
                </Container>
            </Box>
        </Box>
    )
}

export default Header